// Maps backend/network errors to user-friendly text; falls back to the original.
export function friendlyError(message: string, statusCode?: number): string {
  if (statusCode === 401)
    return 'Your session expired. Please refresh the page to re-authenticate.';
  if (statusCode === 403)
    return "You don't have access to this tool. Contact the forecasting-essentials team for permissions.";
  if (message.includes('not found in FGDS'))
    return `${message}. Verify the ID or try a different business.`;
  if (message.includes('Invalid FGID'))
    return `${message}. Use numeric IDs like 100004.`;
  if (message.includes('Invalid Site ID'))
    return `${message}. Use alphanumeric IDs like UMD1.`;
  if (message.includes('timed out'))
    return 'Query took too long. Try a shorter date range or fewer FGIDs/sites.';
  if (message.includes('Failed to fetch') || message.includes('Network Error'))
    return 'Network error. Check your connection and try again.';
  if (message.includes('Unable to access'))
    return 'Unable to access data table. Contact the forecasting-essentials team for permissions.';
  return message || `Something went wrong${statusCode ? ` (HTTP ${statusCode})` : ''}. Please try again.`;
}
